import { render, staticRenderFns } from "./ChemicalCreate.vue?vue&type=template&id=4109d024&"
import script from "./ChemicalCreate.vue?vue&type=script&lang=js&"
export * from "./ChemicalCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports